import { useTheme } from "@mui/material";
import { MobileDatePicker, MobileDatePickerProps } from "@mui/x-date-pickers";

const BybDatePicker = (props: MobileDatePickerProps<Date, Date>) => {
  const theme = useTheme();
  return (
    <MobileDatePicker
      {...props}
      DialogProps={{
        sx: {
          "& .MuiPaper-root": {
            backgroundColor: "dsBase.v100",
            borderRadius: theme.spacing(2),
            "& .MuiTypography-overline": {
              ...theme.typography.textBase500,
              color: "dsNeutral.v400",
              textTransform: "capitalize",
            },
            "& .MuiTypography-h4": {
              ...theme.typography.text2xl700,
              color: "dsBase.v200",
              textTransform: "capitalize",
            },
            "& .MuiIconButton-root": {
              color: "dsBase.v200",
            },
            "& .MuiPickersCalendarHeader-label": {
              ...theme.typography.textLg600,
              color: "dsBase.v200",
              textTransform: "capitalize",
            },
            "& .MuiButton-root": {
              ...theme.typography.textLg600,
              color: "dsPrimary.v400",
              textTransform: "capitalize",
            },
            "& .MuiClock-pin, & .MuiClockPointer-root": {
              backgroundColor: "dsPrimary.v400",
            },
            "& .MuiClockPointer-thumb": {
              backgroundColor: "dsPrimary.v400",
              border: "16px solid",
              borderColor: "dsPrimary.v400",
            },
          },
        },
      }}
    />
  );
};

export default BybDatePicker;
